var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('ns-header-top'),_c('ns-header-mid')],1)}
var staticRenderFns = []

export { render, staticRenderFns }